module.exports = __webpack_public_path__ + "static/media/2pic.4a52926e.png";